/**
 * Translates equipment names from ExerciseDB API
 * into the user's current language via i18n keys.
 */

const EQUIP_KEY_MAP: Record<string, string> = {
  "body weight": "fitness.equip.bodyweight",
  barbell: "fitness.equip.barbell",
  dumbbell: "fitness.equip.dumbbell",
  cable: "fitness.equip.cable",
  kettlebell: "fitness.equip.kettlebell",
  "leverage machine": "fitness.equip.machine",
  "smith machine": "fitness.equip.machine",
  band: "fitness.equip.band",
  "resistance band": "fitness.equip.band",
  "ez barbell": "fitness.equip.ezbar",
  hammer: "fitness.equip.hammer",
  "medicine ball": "fitness.equip.medicineball",
  "stability ball": "fitness.equip.stabilityball",
  roller: "fitness.equip.roller",
  rope: "fitness.equip.rope",
  "olympic barbell": "fitness.equip.barbell",
  trap_bar: "fitness.equip.barbell",
  weighted: "fitness.equip.weighted",
  assisted: "fitness.equip.assisted",
  bosu_ball: "fitness.equip.bosuball",
};

/**
 * Translate an equipment string from ExerciseDB to the current locale.
 * Falls back to the original string (capitalized) if no mapping exists.
 */
export function translateEquipment(
  equipment: string,
  t: (key: string) => string,
): string {
  const key = EQUIP_KEY_MAP[equipment.toLowerCase()];
  if (key) return t(key);
  return equipment.charAt(0).toUpperCase() + equipment.slice(1);
}
